import { useContext, useState } from "react";
import Table, { TableProps } from "~/components/UI/Table/Table";
import EvPortOptions from "./EvPortOptions";
import { useTranslation } from "react-i18next";
import { i18nTableColumn } from "~/packages/i18n";
import { PERMISSION } from "~/api/permissions/enums";
import usePermissions from "~/hook/usePermissions";
import EvPortsContext from "./evPortsContext";

const defaultColumns = [
  {
    key: "portType",
    sort: true,
    i18nKey: "label.portType",
  },
  {
    key: "articleCode",
    sort: true,
    i18nKey: "label.articleCode",
  },
  {
    key: "articleName",
    i18nKey: "label.articleName",
  },
  {
    key: "options",
    cellOptions: {
      align: "right",
      padding: "none",
      width: 70,
    },
  },
];

/**
 * @memberof EvPorts
 * @component
 * @desc Table for displaying EV Port mappings.
 * @property {Api.EvPortDto[]} dataSource - EvPorts data
 * @requires EvPortsContext
 */

const EvPortTable = (props: Omit<TableProps<Api.EvPortDto>, "columns">) => {
  const { onSelect, onSort } = useContext(EvPortsContext);
  const { t } = useTranslation();
  const { hasAll } = usePermissions();
  const [rowSelection] = useState(
    hasAll(PERMISSION.DELETE_EV_PORT)
      ? {
        hideSelectAll: false,
        onChange: onSelect,
      }
      : undefined
  );

  const columns = defaultColumns.map((c) => {
    const column = i18nTableColumn(c, t);
    switch (column.key) {
      case "options":
        return {
          ...column,
          render: (_value: unknown, row: Api.EvPortDto) => (
            <EvPortOptions evPort={row} />
          ),
        };
      default:
        return column;
    }
  });

  return (
    <Table
      {...props}
      columns={columns}
      onRequestSort={onSort}
      rowSelection={rowSelection}
      rowKey="portType"
      stickyHeader
    />
  );
};

export default EvPortTable;
